webpackJsonp([5231879925447],{

/***/ 1365:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"BillingNoteInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"attachmentContentType","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"attachmentPath","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"clientId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"datetime","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"note","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-billing-note-input-24d1148ec9f1f8825886.js